import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router";
import { bindActionCreators } from "redux";
import Constants from "../../models/utility/Constants";
import { PermissionType } from "../../providers/SecurityProvider";
import { IAppState } from "../../store";
import * as UserStore from "../../store/UserStore";

type AuthRouteProps = RouteProps &
    UserStore.IUserStoreState &
    typeof UserStore.actionCreators & {
        permission?: PermissionType;
    };

export class AuthRoute extends React.PureComponent<AuthRouteProps> {
    public render() {
        // check login and permission (if passed)
        if (
            !this.props.user ||
            (this.props.permission && !this.props.permission(this.props.user))
        ) {
            return <Redirect to={Constants.Routes.Login()} />;
        }

        // render normally
        const props = { ...this.props };
        delete props.permission;

        return <Route {...this.props} />;
    }
}

export default connect(
    (state: IAppState) => state.userStoreState,
    (dispatch) => bindActionCreators(UserStore.actionCreators, dispatch),
    null,
    { pure: false }
)(AuthRoute);
